<template>
  <component :is="component"></component>
</template>

<script setup>
/**
 * determines which header to show.
 * useful for pages that can be shared between
 * public and authenticated with user types.
 * like the pokemon ditto, it can change its appearance
 * based on circumstances.
 * https://pokemondb.net/pokedex/ditto
 */

import AuthedHeader from '@/components/headers/AuthedHeader.vue'
import PublicHeader from '@/components/headers/PublicHeader.vue'
import { useAuthStore } from '@/stores/auth'
import { shallowRef } from 'vue'

const authStore = useAuthStore()
const component = shallowRef(PublicHeader)

if (!authStore.isLoggedIn || authStore.isPublic) {
  component.value = PublicHeader
} else {
  component.value = AuthedHeader
}
</script>

<style lang="scss" scoped></style>
